var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9863 17.1032C41.2815 17.1032 44.7636 13.6208 44.7636 9.32505C44.7636 5.02928 41.2815 1.54688 36.9863 1.54688C32.691 1.54688 29.209 5.02928 29.209 9.32505C29.209 13.6208 32.691 17.1032 36.9863 17.1032Z",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76752 71.5485C14.0628 71.5485 17.5448 68.0661 17.5448 63.7704C17.5448 59.4746 14.0628 55.9922 9.76752 55.9922C5.47224 55.9922 1.99023 59.4746 1.99023 63.7704C1.99023 68.0661 5.47224 71.5485 9.76752 71.5485Z",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2128 71.5485C68.5081 71.5485 71.9901 68.0661 71.9901 63.7704C71.9901 59.4746 68.5081 55.9922 64.2128 55.9922C59.9176 55.9922 56.4355 59.4746 56.4355 63.7704C56.4355 68.0661 59.9176 71.5485 64.2128 71.5485Z",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9921 55.9908C43.435 55.9908 48.658 50.7672 48.658 44.3235C48.658 37.8799 43.435 32.6562 36.9921 32.6562C30.5492 32.6562 25.3262 37.8799 25.3262 44.3235C25.3262 50.7672 30.5492 55.9908 36.9921 55.9908Z",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9902 17.1055V32.6618",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.373 59.1024L27.2612 51.3242",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5972 59.1024L46.709 51.3242",
    stroke: "#EEF4F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.b369f1044b40f6a845e160fa86ede6c9.svg";
export { ForwardRef as ReactComponent };